import ImageCompressor from "image-compressor.js";
<template lang="pug">
    div.coverPhotoWrapper
        // title
        title-component(
            type="h4"
            :title="$t('sessions.general.coverPhoto')"
        )

        div.uploadWrapper
            div

                // Upload image button
                upload-button.uploadButton(
                    id="avatar"
                    :isLoading="isLoading"
                    :disabled="isLoading"
                    :ext="'image/jpeg,image/png,image/jpg'"
                    :selectedCallback="uploadImage"
                )
                    span {{ $t('defaultButtons.uploadImage') }}

            div(v-if="file.name") {{ file.name }}

                // Remove button
                a.removeButton(@click="removeCoverPhoto()")
                    v-icon(size="16" color="white") close

</template>

<script>
    import { mapGetters } from 'vuex';
    import Handler from '~services/Handler';
    import profile from '~api/profile';
    import Title from '~components/Title';
    import UploadButton from '~components/UploadButton';
    import ImageCompressor from 'image-compressor.js';

    export default {
        components: {
            UploadButton,
            TitleComponent: Title
        },
        data() {
            return {
                file: {
                    name: null,
                    base64: null
                }
            };
        },
        computed: {
            ...mapGetters('auth', ['user', 'isLoading'])
        },
        async created() {
            if (this.user && this.user.avatar_name) {
                this.file.name = this.user.avatar_name;
            }

            if (this.user && this.user.avatar) {
                this.file.base64 = this.user.avatar;
            }
        },
        methods: {
            /**
             * Upload image
             *
             * @param e
             */
            uploadImage(e) {
                let self = this;

                // Clear file value if upload the same file
                document.querySelector('#avatar input').value = '';

                const toBase64 = file =>
                    new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = () => {
                            profile.uploadCoverPhoto({
                                avatar: reader.result,
                                avatar_name: file.name
                            });

                            Handler.handleResponse(
                                { ok: true },
                                this.$t('profile.successMessageAvatarUpdated')
                            );

                            return resolve(reader.result);
                        };
                        reader.onerror = error => reject(error);
                    });

                // Set image data into model
                async function setImage() {
                    // Compress image
                    new ImageCompressor(e, {
                        quality: 0.6,
                        width: 225,
                        async success(result) {
                            // Convert image to base64
                            self.user.avatar = self.file.base64 = await toBase64(
                                result
                            );

                            // Update user data in local storage
                            self.updateUserData(e.name, self.user.avatar);

                            return result;
                        },
                        error(e) {
                            console.log(e.message);
                        }
                    });
                }

                if (e.name) {
                    this.user.avatar_name = this.file.name = e.name;
                    // Compress and set base64 into model~
                    setImage();
                }
            },
            /**
             * Remove cover photo
             */
            async removeCoverPhoto() {
                this.user.avatar_name = this.file.name = null;
                this.user.avatar = this.file.base64 = null;

                // Update user data in local storage
                this.updateUserData(null, null);

                const resp = await profile.removeCoverPhoto(this.user.id);

                if (resp.ok) {
                    Handler.handleResponse(
                        resp,
                        this.$t('profile.successMessageAvatarDeleted')
                    );
                }
            },
            /**
             * Update user data in local storage
             *
             * @param avatarName
             * @param avatarBase64
             */
            updateUserData(avatarName, avatarBase64) {
                let user = JSON.parse(window.localStorage.getItem('user'));
                user.avatar = avatarBase64;
                user.avatar_name = avatarName;
                window.localStorage.setItem('user', JSON.stringify(user));
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../../assets/style/_variables.styl'

    .coverPhotoWrapper
        margin-top: 12px

    .uploadWrapper
        display: flex
        align-items: center

    .uploadButton
        width: auto
        margin: 0 15px 0 0

    .removeButton
        padding-left: 5px

    @media screen and (max-width: $grid-breakpoints.sm - 1)

        .uploadWrapper
            display: flex
            flex-direction: column
            align-items: flex-start

        .uploadButton
            margin: 0 15px 15px 0
</style>
                                           
